import { Box } from "@mui/material";
import { styled } from "@mui/system";

export const Section = styled(Box)(({ theme }) => (props) => ({
    display: 'flex',
    padding: '24px',
    flexDirection: 'column',
    background: '#F4F4F4',
    direction: 'ltr',
    gap: '16px',
    width: '100%',
    margin: '0 auto',
    [theme.breakpoints.down('sm')]: {
        padding: ' 24px 12px',
    },
    [theme.breakpoints.down('xs')]: {
        padding: ' 12px 6px',
    },
}))

export const ContentQuest = styled(Box)(({ theme }) => (props) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    //maxHeight: '75vh',
    // height: '75vh',
    // overflowY: 'auto',
    [theme.breakpoints.down('sm')]: {
        padding: '24px 12px',
        //maxHeight: '60vh',
    },
    [theme.breakpoints.down('xs')]: {
        padding: ' 12px 6px',
        //maxHeight: '60vh',
    },

}))